import { CacheProvider } from '@emotion/react';
import { Lato, Poppins } from '@next/font/google';
import { usePageLoadTracking, useScrollTracking } from '@nrdy-marketing-engine/tracking';
import createEmotionCache from '../src/create-emotion-cache';
import { UserProvider } from '../src/user/context';

const lato = Lato({
  weight: ['400', '700'],
  style: ['normal'],
  display: 'swap',
  subsets: ['latin'],
});

const poppins = Poppins({
  weight: ['400', '700'],
  style: ['normal'],
  display: 'swap',
  subsets: ['latin'],
});

const clientSideEmotionCache = createEmotionCache();

/**
 * The default App which should be default-exported in pages/_app.tsx for any NextJS server.
 *
 * ```
 * export { App as default } from '@nrdy-marketing-engine/server`;
 * ```
 */
export default function MyApp({ Component, pageProps, emotionCache = clientSideEmotionCache }) {
  const font = pageProps?.font === 'poppins' ? poppins : lato;

  useScrollTracking();
  usePageLoadTracking();

  return (
    <CacheProvider value={emotionCache}>
      <UserProvider userContext={pageProps?.userContext}>
        <style global jsx>{`
          :root {
            --font-sans: ${font.style?.fontFamily};
          }
        `}</style>
        <Component {...pageProps} data-trackable="scroll" />
      </UserProvider>
    </CacheProvider>
  );
}
